import { StepSchema } from '@feedyou-ai/feedbot-schema'
import { Mutable } from '@feedyou/utils'

import { Action, actionTypes } from './actions'

export function timeoutReducer(step: Mutable<StepSchema>, action: Action) {
  switch (action.type) {
    case actionTypes.SET_TIMEOUT:
      return { ...step, timeout: action.timeout }

    case actionTypes.SET_DIALOG:
      return { ...step, dialog: action?.dialogId }

    default:
      return step
  }
}
